/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef } from 'react';
import type { CreateProps } from '@atlaskit/atlassian-navigation/create/types';
import { CreateButton as Nav4CreateButton } from '@atlaskit/navigation-system/top-nav-items/create-button';
import { Box } from '@atlaskit/primitives/compiled/box';
import { GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID } from '@jira/navigation-apps__sidebar-common/src/common/constants.tsx';
import { SpotlightTarget } from '@jira/navigation-apps__sidebar-common/src/common/ui/spotlight-target/SpotlightTarget.tsx';
import { GLOBAL_CREATE_BUTTON_NAV4 } from './constants.tsx';

export const Create: React.ForwardRefExoticComponent<
	CreateProps & React.RefAttributes<HTMLButtonElement>
> = forwardRef<HTMLButtonElement, CreateProps>((props, ref): React.JSX.Element => {
	const { onClick, text } = props;

	return (
		<SpotlightTarget name={GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID}>
			<Box>
				<Nav4CreateButton ref={ref} onClick={onClick} testId={GLOBAL_CREATE_BUTTON_NAV4}>
					{text}
				</Nav4CreateButton>
			</Box>
		</SpotlightTarget>
	);
});
